<template>
  <vs-popup
    fullscreen
    :title="`Pengumpulan Syarat ${passData.name}`"
    :active.sync="activatingPopUp"
    @close="closeWithLoad(false)"
    class="p-5"
  >
    <div class="vx-row justify-between mt-2 w-full">
      <section class="vx-col lg:w-2/5 sm:w-full">
        <main>
          <div class="mb-6 items-top">
            <section class="vx-row">
              <span
                :class="
                  itemEdit === null
                    ? 'text-black text-xl vx-col w-full'
                    : 'text-black text-xl vx-col w-4/5 overflow-visible'
                "
                ><strong>{{ titlePopUp }}</strong></span
              >
              <vs-icon
                v-if="itemEdit !== null"
                class="vx-col w-1/5 cursor-pointer"
                icon="clear"
                size="medium"
                color="#383838"
                @click="closeEdit"
              ></vs-icon>
            </section>
          </div>
          <div class="flex justify-start w-full gap-4 items-center mb-base">
            <vs-icon
              v-if="formData.file === ''"
              icon="attach_file"
              size="medium"
              color="grey"
              bg="white"
              rounded
            ></vs-icon>
            <div
              v-else
              class="rounded-lg shadow-md bg-grey cursor-pointer block mb-4 p-6 place-items-center"
            >
              <h2>
                <strong>{{
                  binaryFile !== ""
                    ? binaryFile.name.split(".").slice(-1)[0]
                    : formData.file.split(".").slice(-1)[0]
                }}</strong>
              </h2>
            </div>
            <div>
              <p class="text-black text-sm mb-2" v-if="formData.file !== ''">
                {{
                  binaryFile !== ""
                    ? binaryFile.name.split("/").slice(-1)[0]
                    : formData.file.split("/").slice(-1)[0]
                }}
              </p>
              <input
                type="file"
                class="hidden"
                ref="updateImgInput"
                @change="updateCurrFile"
                accept=".pdf,.doc,.docx,.xls,.ppt,.pptx,.png,.jpeg,.jpg,.txt,.zip,.rar,.z7,.gz"
              />
              <vs-button class="mr-4 sm:mb-0 mb-2" @click="$refs.updateImgInput.click()"
                >Upload File</vs-button
              >
              <!-- <p class="text-sm mt-2">Allowed JPG, GIF or PNG. Max size of 800kB</p> -->
            </div>
          </div>
          <div class="mb-4">
            <section class="mb-2 flex justify-start gap-1">
              <h6>Deskripsi</h6>
              <span class="text-danger">*</span>
            </section>
            <vs-textarea
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="description"
              class="w-full sidebar-input"
              v-model="formData.deskripsi"
              placeholder="Isi Dengan Deskripsi"
            />
            <span class="text-danger text-sm">{{ errors.first("description") }}</span>
          </div>
          <div class="mb-4">
            <section class="mb-2 flex justify-start gap-1">
              <h6>Status</h6>
              <span class="text-danger">*</span>
            </section>
            <v-select
              :options="statusList"
              :reduce="(v) => v.id"
              class="w-full"
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="status"
              label="text"
              v-model="formData.status"
              placeholder="Pilih Status"
            />
            <span class="text-danger text-sm">{{ errors.first("status") }}</span>
          </div>
          <div class="mb-4">
            <section class="mb-2 flex justify-start gap-1">
              <h6>Syarat</h6>
            </section>
            <vs-input
              v-if="passData.name"
              v-validate="'required'"
              data-vv-validate-on="blur"
              class="w-full sidebar-input"
              :disabled="true"
              v-model="passData.name"
              placeholder="Isi Dengan Syarat SOS"
            />
          </div>
        </main>
        <footer class="mt-4">
          <div class="flex justify-end items-center mr-4 mb-4">
            <!-- <vs-button
          color="danger"
          class="mr-2 rounded-2xl"
          @click="closeWithLoad(false)"
          >Cancel</vs-button
        > -->
            <vs-button
              :color="itemEdit === null ? 'success' : 'warning'"
              class="ml-2 rounded-2xl"
              :disabled="!validateForm"
              @click="addWithOption"
              >{{ labelButton }}</vs-button
            >
          </div>
        </footer>
      </section>
      <section class="vx-col lg:w-3/5 sm:w-full">
        <header class="w-full">
          <div class="mb-base vx-row justify-between items-top">
            <section
              class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-start"
            >
              <span class="text-black text-xl"
                ><strong>Tabel Syarat yang Terkumpul</strong></span
              >
            </section>
            <!-- <section
              class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-end"
            >
              <vs-button @click="openPopUp(null)" v-if="access.create === 1"
                >Tambah Kategori SOS</vs-button
              >
            </section> -->
          </div>
          <div class="vx-row justify-between items-center">
            <section class="mb-base vx-col md:w-2/5 lg:w-2/5 xl:w-2/5 sm:w-full">
              <div class="w-full gap-2 flex justify-start items-center">
                <vs-button @click="actionsDelete">{{
                  selected.length === 0 ? "Hapus" : `Hapus ${selected.length} Item`
                }}</vs-button>
                <!-- <vs-dropdown vs-trigger-click class="cursor-pointer">
                  <vs-button icon-after icon="expand_more">Aksi</vs-button>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="dialogDelete">
                      <span>Hapus</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
                <vs-dropdown vs-trigger-click class="cursor-pointer">
                  <div
                    class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                  >
                    <span class="mr-2">{{ `entries ${limit}` }}</span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button>
                  <vs-dropdown-menu>
                    <vs-dropdown-item
                      v-for="(item, index) in limitDataTables"
                      :key="index"
                      @click="limit = item"
                    >
                      <span>{{ item }}</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown> -->
              </div>
            </section>
            <section class="mb-base vx-col md:w-3/5 lg:w-3/5 xl:w-3/5 sm:w-full">
              <div class="w-full flex justify-end gap-2 flex-wrap items-center">
                <vs-input v-model="search" placeholder="Search..." />
              </div>
            </section>
          </div>

          <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <div
            class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
          ></div>
        </header>

        <main ref="loadSyaratKumpul">
          <vs-table
            stripe
            :data="syaratKumpuls"
            v-model="selected"
            :max-items="limit"
            pagination
            multiple
          >
            <template slot="thead">
              <vs-th>File</vs-th>
              <vs-th>Status</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].file">
                  {{ data[indextr].file }}
                </vs-td>
                <vs-td
                  :data="data[indextr].status"
                  :class="data[indextr].status === 1 ? 'success' : 'danger'"
                >
                  {{ data[indextr].status === 1 ? "Aktif" : "Tidak Aktif" }}
                </vs-td>
                <vs-td>
                  <div
                    class="flex justify-start gap-2"
                    v-if="itemDelete !== data[indextr].id"
                  >
                    <vs-button
                      color="primary"
                      type="filled"
                      icon-pack="feather"
                      icon="icon-edit"
                      @click="openEdit(data[indextr])"
                    >
                    </vs-button>
                    <vs-button
                      color="danger"
                      type="filled"
                      icon-pack="feather"
                      icon="icon-trash"
                      @click="itemDelete = data[indextr].id"
                    >
                    </vs-button>
                  </div>
                  <div class="flex justify-start gap-2" v-else>
                    <vs-button
                      color="danger"
                      type="filled"
                      icon-pack="feather"
                      icon="icon-trash"
                      @click="deleteItem(data[indextr].id)"
                    >
                      Delete
                    </vs-button>
                    <vs-button
                      color="#949494"
                      type="filled"
                      icon-pack="feather"
                      icon="icon-x"
                      @click="itemDelete = null"
                    >
                      No
                    </vs-button>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </main>
      </section>
    </div>
  </vs-popup>
</template>

<script>
import limitDataTables from "@/limitDataTable.js";
import emptyImage from "@/assets/images/elements/empty.png";
import url from "@/url.js";

export default {
  props: {
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null },
  },
  data() {
    return {
      emptyImage,
      url,
      statusList: [
        {
          id: 1,
          text: "Aktif",
        },
        {
          id: 2,
          text: "Tidak Aktif",
        },
      ],
      params: {},
      limitDataTables,
      binaryFile: "",
      limit: limitDataTables[0],
      active: false,
      itemDelete: null,
      itemEdit: null,
      selected: [],
      access: null,
      tableList: [
        "vs-th: Component",
        "vs-tr: Component",
        "vs-td: Component",
        "thread: Slot",
        "tbody: Slot",
        "header: Slot",
      ],
      syaratKumpuls: [],
      search: "",
      formData: {
        user_id: null,
        deskripsi: "",
        file: "",
        status: null,
      },
    };
  },
  computed: {
    profile() {
      return this.$store.state.auth.profileAccess;
    },
    titlePopUp() {
      return this.itemEdit != null ? "Edit File Persyaratan" : "Tambah File Persyaratan";
    },
    labelButton() {
      return this.itemEdit != null ? "Edit" : "Submit";
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.formData.deskripsi !== "" &&
        this.formData.file !== "" &&
        this.formData.status !== null
      );
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
  },
  watch: {
    // activate() {
    //   if (this.activate === true) {
    //     this.getData();
    //   }
    // },
    search() {
      if (this.search !== "" || this.search !== null) {
        this.params = {
          search: this.search,
        };
      } else {
        this.params = {};
      }

      this.getData();
    },
  },
  methods: {
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
    },
    openEdit(val) {
      this.formData.deskripsi = val.deskripsi;
      this.formData.file = val.file;
      this.formData.status = val.status;
      this.itemEdit = val;
    },
    resetForm() {
      this.binaryFile = "";
      this.formData.deskripsi = "";
      this.formData.file = "";
      this.formData.status = null;
    },
    closeEdit() {
      this.resetForm();
      this.itemEdit = null;
    },
    actionsDelete() {
      if (this.selected.length === 0) {
        this.$vs.notify({
          title: "Tidak ada item yang dipilih",
          text: "Pilihlah salah satu item atau semua item",
          color: "danger",
          position: "top-right",
        });
      } else {
        for (let i in this.selected) {
          this.deleteItem(this.selected[i].id);
        }
      }
    },
    // dialogDelete(val) {

    //   this.$vs.dialog({
    //     type: "confirm",
    //     color: "danger",
    //     title: name && id ? `Hapus ${name} ?` : "Hapus Item Terpilih ?",
    //     text:
    //       name && id
    //         ? `Anda yakin ingin menghapus item ${name}`
    //         : "Anda yakin ingin menghapus item yang terpilih",
    //     accept: () => {
    //       if (name && id) {
    //         this.delete(id);
    //       } else {
    //         // eslint-disable-next-line no-lonely-if
    //         if (this.selected.length === 0) {
    //           this.$vs.notify({
    //             title: "Tidak ada item yang dipilih",
    //             text: "Pilihlah salah satu item atau semua item",
    //             color: "danger",
    //             position: "top-right",
    //           });
    //         } else {
    //           // eslint-disable-next-line prefer-const
    //           for (let i in this.selected) {
    //             this.delete(this.selected[i].id);
    //           }
    //         }
    //       }
    //     },
    //   });
    // },
    deleteItem(id) {
      this.$vs.loading({
        container: this.$refs.loadSyaratKumpul,
        color: "primary",
      });
      this.closeEdit();
      const fungsi = {
        fungsi: 1,
      };
      this.$store
        .dispatch("sos/cudSyaratKumpulSOS", [Object.assign(fungsi, { id: id })])
        .then((v) => {
          this.$vs.notify({
            position: "top-right",
            title: "Menghapus Sukses!",
            text: `File Persyaratan ${v.file.split("/").splice(-1)[0]} Berhasil dihapus`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
          this.selected = [];
          this.getData();
          this.itemDelete = null;
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadSyaratKumpul);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    addWithOption() {
      this.$vs.loading({
        color: "primary",
      });
      if (this.binaryFile === "") {
        this.addData();
      } else {
        this.addWithFile();
      }
    },
    addWithFile() {
      this.$store
        .dispatch("file/addFile", this.binaryFile)
        .then((v) => {
          this.formData.file = `${this.url.baseFl}/${v.link}`;
          this.addData();
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.selected = [];
          this.closeEdit();
        });
    },
    getData() {
      this.$vs.loading({
        container: this.$refs.loadSyaratKumpul,
        color: "primary",
      });
      let user_id = {};
      if (this.profile.profile.level.id !== 2) {
        user_id = {
          user_id: this.profile.profile.id,
        };
      }
      this.$store
        .dispatch("sos/getSyaratKumpulSOS", {
          ...this.params,
          syarat_id: this.passData.id,
          ...user_id,
        })
        .then((v) => {
          this.$vs.loading.close(this.$refs.loadSyaratKumpul);
          this.syaratKumpuls = v.data;
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadSyaratKumpul);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    addData() {
      let idData = {};
      if (this.itemEdit !== null) {
        idData = {
          id: this.itemEdit.id,
        };
      }
      this.formData.user_id = this.profile.profile.id;
      this.$store
        .dispatch("sos/cudSyaratKumpulSOS", [
          { ...this.formData, syarat_id: this.passData.id, ...idData },
        ])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title:
              this.itemEdit !== null
                ? "Edit File Persyaratan Sukses!"
                : "Tambah File Persyaratan Sukses!",
            text:
              this.itemEdit !== null
                ? `File Persyaratan ${v.file.split("/").splice(-1)[0]} Berhasil diedit`
                : `File Persyaratan ${v.file.split("/").splice(-1)[0]} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
          this.getData();
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          idData = {};
          this.selected = [];
          this.closeEdit();
        });
    },
    updateCurrFile(input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.formData.file = e.target.result;
          this.binaryFile = input.target.files[0];
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
  },
  mounted() {
    this.getData();
  },
  created() {
    // if (this.$store.state.auth.profileAccess !== null) {
    //   if (
    //     this.$store.state.auth.profileAccess.menu.find(
    //       (e) => e.menu.url === "/dashboard/sub-kategori-SOS"
    //     )
    //   ) {
    //     this.access = this.$store.state.auth.profileAccess.menu.find(
    //       (e) => e.menu.url === "/dashboard/sub-kategori-SOS"
    //     );
    //   }
    // }
  },
};
</script>

<style lang="scss" scoped>
.img {
  max-height: 800px;
  max-width: 800px;
  overflow: auto;
}
</style>
